import { render, staticRenderFns } from "./AnnouncementPushJG.vue?vue&type=template&id=5c2cc720"
import script from "./AnnouncementPushJG.vue?vue&type=script&lang=js"
export * from "./AnnouncementPushJG.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPushJG.vue?vue&type=style&index=0&id=5c2cc720&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports